import { useState, useEffect } from "react";
import React from 'react';
import instance from "./axios";
import requests from "./request";
import "./Banner.css"

function Banner() {
    const [movies, setMovies] = useState([]);

    useEffect(() => {
        async function fetchData() {
            const request = await instance.get(requests.fetchNetflixOriginals);
            setMovies(request.data.results[Math.floor(Math.random() * request.data.results.length - 1)]);
            return request;
        }
        fetchData();

    }, []);
    
    function truncate(str, n) {
		return str?.length > n ? str.substr(0, n - 1) + "..." : str;
	};

    return (
      
        <header className="banner"
            style={{
                backgroundSize: "cover",
                backgroundImage: `url("https://image.tmdb.org/t/p/original/${movies?.backdrop_path}")`,
                backgroundPosition: "top",
                position: "relative",
                backgroundRepeat: "no-repeat",
            
            }}>
            <div className="banner_content">
                <h1 className="banner_title">{ movies?.name || movies?.title || movies?.original_name}</h1>
                
                <div className="banner_buttons">
                    <button className="banner_button">Play</button>
                    <button className="banner_button">My List</button>
                </div>
                <h1 className="banner_description">
                    {truncate( movies?.overview,150)}

                </h1>
            </div>

            <div className="banner--fadeBottom"></div>
            
      
        </header>
  )
}

export default Banner;
